module.exports = __webpack_public_path__ + "static/googleAnalytics-60f79ef76b33c399ae8aa4beba9a1742.svg";